import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface counsel{
    action_detail:string,
    counsel_date:string,
    counsel_detail:string,
    id:string,
}

const useCounselList = (studentUid:string) => {
    const [list, setList] = useState<counsel[]>([]);
    const {getBranchId} = useGetBranchId();
    const {readFirestoreWithSort} = useFirestore();

    useEffect(() => {
        // readFirestoreWithQuery(`Counsel`).then(res => {
        //     let data_list:any = [];
        //     res.forEach((doc:any) => {
        //         data_list.push(doc.data());
        //     })
        //     data_list.sort((a:counsel, b:counsel) => {
        //         if (a.counsel_date > b.counsel_date) {
        //             return -1;
        //           }
        //           if (a.counsel_date < b.counsel_date) {
        //             return 1;
        //           }
        //           // a must be equal to b
        //           return 0;
        //     })
        //     setList(data_list);
        // })
        getCounselList();
    }, [studentUid])

    const getCounselList = async() => {
        const branch_id = await getBranchId();
        const list = await readFirestoreWithSort(`Counsel/${branch_id}/${studentUid}`, {name:"counsel_date", direction:"desc"}).then(res => {
            const list:counsel[] = [];
            if(res.empty){
                return [];
            }
            const doc_list = res.docs;
            for(const doc of doc_list){
                const data = doc.data();
                list.push({
                    action_detail:data.action_detail,
                    counsel_date:data.counsel_date,
                    counsel_detail:data.counsel_detail,
                    id:doc.id
            })
            }
            return list;
        })

        setList(list);
    }
    
    return {list}
}

export default useCounselList;